export default "__VITE_ASSET__D$KMOwLI__"